export default {
  title: 'Statistica pieței imobiliare în provincia Antalya',
  tabs: {
    sales: 'Vânzări imobiliare',
    permits: 'Autorizații de construcție'
  }
}
